const ArrowRisk = () => (
  <svg width="14" height="11" viewBox="0 0 14 11" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M0.505127 8.6829L5.56897 0.887248C6.1521 -0.0104705 7.46088 -0.0259591 8.0651 0.857707L13.3955 8.65335C14.0762 9.64891 13.3633 11 12.1572 11H1.76304C0.573085 11 -0.143084 9.6808 0.505127 8.6829Z"
      fill="#27272A"
    />
  </svg>
)

export default ArrowRisk
